angular
  .module('contrast.directives.quickfilters', [])
  .directive('quickFilters', function () {
    return {
      restrict: 'A',
      scope: {
        quickFilters: '=',
        selected: '=',
        onSelect: '&',
        quickFiltersClass: '@',
        shouldDisableCounts: '='
      },
      templateUrl: 'views/common/quick_filters.html',
      link: function ($scope) {
        angular.extend($scope, {
          filter: $scope.selected,

          filterSelected: filterSelected
        })

        function filterSelected(item) {
          $scope.onSelect({ filter: item })
        }

        $scope.$watch(
          function () {
            return (
              $scope.selected &&
              $scope.selected.name &&
              $scope.selected.name + $scope.selected.count
            )
          },
          function (newVal) {
            if (newVal) {
              $scope.filter = $scope.selected
            }
          }
        )
      }
    }
  })
